import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import firebase from 'firebase/compat/app';

@Injectable({
    providedIn: 'root'
})
export class DbService {

    createId = this.ngFirestore.createId;
    firestore = this.ngFirestore.firestore;
    constructor(
        private ngFirestore: AngularFirestore
    ) { }

    getData(projectId: string, path: string) {
        return this.firestore.collection('projects').doc(projectId).collection(path).get();
    }

    getCollectionData(projectId: string, path: string): firebase.firestore.CollectionReference<firebase.firestore.DocumentData> {
        return this.firestore.collection('projects').doc(projectId).collection(path);
    }

}
